<template>
  <div
    class="col-12 col-md-6 col-xl-4 col-wrap"
    :style="{
      backgroundImage: `url(//www.animlab.yuntech.edu.tw/upload/2021/course/${course.image})`,
    }"
    style="background-size: cover"
  >
    <div class="course-block">
      <div class="slide-up">
        <div class="course h2-style">
          <a :href="course.link" target="_blank">{{ course.title }}</a>
        </div>
        <div class="instructor">
          <a :href="course.link" target="_blank">{{ course.lecturer }}</a>
        </div>
        <div class="d-flex">
          <a :href="course.link" class="tag-link" target="_blank">
            <img :src="linkArrow" alt=""
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import linkArrow from '@/assets/img/link_arrow.png';
import y1 from '@/assets/img/y1.png';
import y2 from '@/assets/img/y2.png';
import y3 from '@/assets/img/y3.png';
import y4 from '@/assets/img/y4.png';
import y5 from '@/assets/img/y5.png';

export default {
  props: {
    course: { type: Object, required: true },
  },
  data() {
    return {
      linkArrow,
      img: [y1, y2, y3, y4, y5],
    };
  },
};
</script>

<style lang="stylus" scoped>
.col-wrap
  background-repeat: no-repeat;
  background-size: cover;

.course-block
  position: relative;
  width: 100%;
  height: 200px;
  padding: 20px;
  overflow: hidden;
  background-image: linear-gradient(
    rgba(95, 95, 95, 0) 33.79%,
    rgba(0, 0, 0, 0.5) 100%
  );

  .slide-up
    position: absolute;
    padding: 16px;
    left: 0;
    right: 0;
    bottom: -250px;
    transition: all 0.3s linear;

  &:hover
    background-color: rgba(244, 243, 238, 0.8);
    mix-blend-mode: alpha;

    .slide-up
      bottom: 0;

// .course
// color: $monoc1;
// margin-top: 134px;
.instructor
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  margin-top: 8px;
  margin-bottom: 16px;

.tag-link
  margin-top: 24px;

  img
    width: 36px;

a
  &, &:hover, &:focus, &:active
    color: $monoc4;
    text-decoration: none;
</style>
